import React, { FC, useEffect, useState } from "react";
import { useAppSelector } from "@/hooks/hook";
import { GET, POST } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import DashboardHeader from "@/components/DashboardHeader";
import { Link } from "react-router-dom";
import { Cocktail } from "@/interfaces/Cocktail";
import CocktailCard from "@components/cocktailCard/CocktailCard"
import { Loader } from "@thdinc/hpf-shared";

const CocktailsPage = () => {
  const { cocktail, toggleCocktailApi } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const { business_id } = useAppSelector((store) => store.user);
  const [cocktailsByCategory, setCocktailsByCategory] = useState<{ [key: string]: Cocktail[] }>({});
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const result = await GET(`${cocktail}/${business_id}`, refreshToken);
        setCocktailsByCategory(result.data);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);
  // toggle cocktail status
  const toggleCocktail = async (cocktailId: string, status: string) => {
    const updatedCocktailList: any = Object.fromEntries(
      Object.entries(cocktailsByCategory).map(([category, cocktails]) => {
        const updatedCocktails = cocktails.map((item) =>
          item.id === cocktailId ? { ...item, status } : item
        );
        return [category, updatedCocktails];
      })
    );
    setCocktailsByCategory(updatedCocktailList);
    try {
      await POST(
        `${toggleCocktailApi}/${cocktailId}`,
        { status },
        refreshToken
      );
    } catch (error) {
      console.log("Failed to toggle cocktail status", error);
      // Optionally: rollback state if API fails
    }
  };
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  const filteredCocktailsByCategory = Object.entries(cocktailsByCategory).reduce(
    (acc, [category, cocktails]) => {
      const filtered = cocktails.filter(cocktail =>
        cocktail.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      if (filtered.length > 0) {
        acc[category] = filtered;
      }
      return acc;
    },
    {} as { [key: string]: Cocktail[] }
  );
  return (
    <div>
      <div className="">
        <DashboardHeader width="w-full" title="Cocktails">
          <div className="flex items-center gap-3 flex-wrap md:flex-nowrap mt-2 md:mt-0 ">
            <input
              type="text"
              placeholder="Search Cocktail Name"
              onChange={handleSearch}
              className="w-full md:min-w-64 px-4 py-3  rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              name=""
              id=""
            />
            <Link
              to="/cocktails/new"
              className="bg-black text-white  rounded-full py-2 px-6 min-w-36"
            >
              {" "}
              <span className="text-lg">+</span> Add New
            </Link>
          </div>
        </DashboardHeader>
        {/* Cocktails List */}
        <div className="flex flex-col gap-4 mt-4">
          {isLoading ? <Loader color="bg-red-500" /> :
            <>{Object.entries(filteredCocktailsByCategory).map(([category, cocktails]) => (
              <CocktailCard key={category} title={category} cocktails={cocktails} toggleCocktail={toggleCocktail} />
            ))}</>}
        </div>
      </div>
    </div>
  );
};

export default CocktailsPage;
